import { Theme } from "@mui/material/styles";
import { CustomTheme } from "enums/customTheme";
import { RootState, useSelector } from "redux/store";
// ----------------------------------------------------------------------

export default function Table(theme: Theme) {
  const customTheme = useSelector(
    (state: RootState) => state.supplier.supplier?.customTheme,
  );
  return {
    MuiTableRow: {
      styleOverrides: {
        root: {
          border: `solid 1px ${theme.palette.text.borderLine}`,
          "&.Mui-selected": {
            backgroundColor: theme.palette.action.selected,
            "&:hover": {
              backgroundColor: theme.palette.action.hover,
            },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: "none",
        },
        head: {
          color:
            customTheme === CustomTheme.Volotea
              ? theme.palette.volotea.grey
              : theme.palette.text.primary,
          "&:first-of-type": {
            paddingLeft: theme.spacing(3),
            // boxShadow: `inset 8px 0 0 ${theme.palette.background.paper}`,
          },
          "&:last-of-type": {
            paddingRight: theme.spacing(3),
            // borderTopRightRadius: theme.shape.borderRadius,
            // borderBottomRightRadius: theme.shape.borderRadius,
            // boxShadow: `inset -8px 0 0 ${theme.palette.background.paper}`,
          },
        },
        stickyHeader: {
          backgroundColor: theme.palette.background.paper,
          backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.paper} 0%, ${theme.palette.background.neutral} 100%)`,
        },
        body: {
          "&:first-of-type": {
            paddingLeft: theme.spacing(3),
          },
          "&:last-of-type": {
            paddingRight: theme.spacing(3),
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          borderTopLeftRadius: theme.shape.borderRadius,
          borderTopRightRadius: theme.shape.borderRadius,
          border: `solid 1px ${theme.palette.text.borderLine}`,
          color: theme.palette.text.primary,
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          border: `solid 1px ${theme.palette.divider}`,
          borderTop: "none",
          borderBottomRightRadius: theme.shape.borderRadius,
          borderBottomLeftRadius: theme.shape.borderRadius,
        },
        toolbar: {
          height: 64,
        },
        select: {
          "&:focus": {
            borderRadius: theme.shape.borderRadius,
          },
        },
        actions: {
          previousButton: {
            bgcolor: "yellow",
          },
        },
        selectIcon: {
          IconComponent: theme.components?.MuiSvgIcon?.styleOverrides?.root,
          width: 20,
          height: 20,
          marginTop: -4,
        },
      },
    },
  };
}
